module.exports = __webpack_public_path__ + "static/media/gateway-online.3f095362.svg";